import { FC, useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import { AppContext } from "../../appContext/AppContext";
import { CODE } from "../../utils/Constant";
import TextField from "../../component/TextField";
import { downloadTemplateTonDauKy, importTonDauKy } from "../services/ThongKeServices";

interface Props {
  show: boolean;
  onHide: () => void;
  nhomVatTu: any;
  onImported?: () => void;
}

const DialogNhapTonDauKy: FC<Props> = ({ show, onHide, nhomVatTu, onImported }) => {
  const { setIsLoading } = useContext(AppContext);

  const handleDownloadTemplate = async () => {
    try {
      setIsLoading(true);
      const res = await downloadTemplateTonDauKy();
      if (CODE.SUCCESS === res.status) {
        saveAs(res.data, "Mẫu nhập tồn kho đầu kỳ.xlsx");
        toast.success("Lưu file mẫu thành công");
      }
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra, vui lòng thử lại !");
    } finally {
      setIsLoading(false);
    }
  };

  const handleImport = async (e: any) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!nhomVatTu?.id) return toast.warning("Vui lòng chọn nhóm vật tư");
    try {
      setIsLoading(true);
      const { data } = await importTonDauKy(file, nhomVatTu?.id);
      if (CODE.SUCCESS === data?.code) {
        toast.success("Nhập tồn kho đầu kỳ thành công");
        onImported?.();
        onHide();
      } else {
        toast.error(data?.message || "Có lỗi xảy ra, vui lòng thử lại !");
      }
    } catch (error: any) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Có lỗi xảy ra, vui lòng thử lại !");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered animation className="background__modal dialog-background">
      <Modal.Header className="header-modal" closeButton>
        <Modal.Title className="text-white text-uppercase">Nhập tồn đầu kỳ</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="d-flex justify-content-center gap-3">
          <Button className="btn-fill" onClick={handleDownloadTemplate}>
            Tải mẫu nhập tồn kho đầu kỳ
          </Button>
          <Button className="btn-fill position-relative">
            Nhập tồn kho đầu kỳ
            <TextField
              className="btn-file"
              type="file"
              name="fileNhapTonDauKy"
              onChange={(e: any) => handleImport(e)}
            />
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end p-2 border-top">
        <Button className="btn-outline min-w-80px" onClick={onHide}>
          Đóng
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DialogNhapTonDauKy;
